var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"FilterBox"},[_c('label',{staticClass:"d-block"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"items d-flex gap-sm"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }